import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

const CATS = ["Inappropriate behaviour", "Harassment", "Request for sexual services", "No-show", "Late arrival", "Payment issue", "Fake profile", "Other"];

export const ReportDialog = ({ trigger, type = "report", companionId, bookingId, title = "Report a concern" }) => {
  const [open, setOpen] = useState(false);
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/tickets", { type, category, description, companion_id: companionId || null, booking_id: bookingId || null });
      toast.success("Submitted. Our safety team will review it.");
      setOpen(false);
      setDescription("");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent data-testid="report-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{title}</DialogTitle>
          <DialogDescription>Reports are confidential. In an emergency call 112 first.</DialogDescription>
        </DialogHeader>
        <Select value={category} onValueChange={setCategory}>
          <SelectTrigger data-testid="report-category-select"><SelectValue placeholder="Select a category" /></SelectTrigger>
          <SelectContent>{CATS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
        <Textarea data-testid="report-description-input" rows={4} placeholder="Describe what happened (min 10 characters)" value={description} onChange={(e) => setDescription(e.target.value)} />
        <Button data-testid="report-submit-btn" disabled={busy || !category || description.length < 10} onClick={submit}>Submit</Button>
      </DialogContent>
    </Dialog>
  );
};
